import React from "react";
import CotizacionFormPage from "../component/Cotizacion/CotizacionFormPage";

const CotizacionNueva = () => <CotizacionFormPage mode="create" />;

export default CotizacionNueva;
